import type { IconProps } from './IconProps';

export const ChevronTriangleDownSmallIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    width={props.width ?? 20}
    height={props.height ?? 20}
    {...props}
  >
    <path
      d="M7.93525 8.125C6.89507 8.125 6.30995 9.32135 6.94856 10.1424L9.0133 12.7971C9.51374 13.4405 10.4862 13.4405 10.9867 12.7971L13.0514 10.1424C13.69 9.32135 13.1049 8.125 12.0647 8.125H7.93525Z"
      fill="currentColor"
    />
  </svg>
);
